import {
  IonCol,
  IonGrid,
  IonItemDivider,
  IonLabel,
  IonList,
  IonRow,
  useIonViewDidEnter,
  useIonViewDidLeave,
  useIonViewWillEnter,
} from '@ionic/react'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import SingleSelect from '../../components/singleSelect/SingleSelect.component'
import SInput from '../../components/stringInput/StringInput.component'
import { getPickupAddressSelector } from '../../features/pickupAddress/selectors/pickupAddress.selector'
import { getDestinationAddressSelector } from '../../features/destinationAddress/selectors/destinationAddress.selectors'
import * as pickupAddressActions from '../../features/pickupAddress/store/pickupAddress.actions'
import * as destinationAddressActions from '../../features/destinationAddress/store/destinationAddress.actions'
import { getPickupAddressOptionsSelector } from '../../features/options/selectors/pickupAddressOptions.selector'
import Validation from '../../components/validation/Validation.component'
import { PickupAddressConstants } from '../../features/pickupAddress/store/pickupAddress.constants'
import { ICity, ICountyOption, IOption, IOptions, IPNNVOption } from '../../common/common.types'
import GoogleMap from '../../components/googleMap/GoogleMap.component'
import MultiSelect from '../../components/multiSelect/MultiSelect.component'
import { IPHIComponent } from '../../components/phi/phi.component'
import { getDestinationAddressOptionsSelector } from '../../features/options/selectors/destinationAddressOptions.selector'
import './RefRecAddress.component.css'
import { DestinationAddressConstants } from '../../features/destinationAddress/store/destinationAddress.constants'
import useDeviceMetrics from '../../utilities/useDeviceMetrics'
import { setZipState } from '../zip/store/zip.actions'
import { geoLocationKeys, zipCodeKeys } from '../numberPad/NumberPad.types'
import NumberPad from '../numberPad/NumberPad.component'
import { getConfigurationsSelector } from '../../features/configurations/selectors/configurations.selector'
import { IConfigurationsState } from '../../features/configurations/store/configurations.types'
import { IHospitalOption, IHospitalOptions } from '../../features/options/store/options.types'
import { getRecCityNemsisCode, getRefCityNemsisCode } from '../../features/locationSearch/store/locationSearch.actions'
import ValidationMessage from '../validation/ValidationMessage.component'
import { getLocationSearchState } from '../../features/locationSearch/selectors'
import { ILocationSearchState } from '../../features/locationSearch/store/locationSearch.types'
import { ICommonAddressesOption } from '../../features/pickupAddress/store/pickupAddress.types'
import { getTripInformationSelector } from '../../features/tripInformation/selectors'

export interface IRefRecAddress extends IPHIComponent {
  addressTypeSelected: number
}

const RefRecAddress: React.FC<IRefRecAddress> = (props: IRefRecAddress) => {
  const { t } = useTranslation()
  const { isPHI, addressTypeSelected } = props
  const dispatch = useDispatch()
  const [flag, setFlag] = useState(true)
  const [isFocused, setIsFocused] = useState(false)
  const { isTablet: isTabletDevice } = useDeviceMetrics()
  const pickupAddressState = useSelector(getPickupAddressSelector)
  const destinationAddressState = useSelector(getDestinationAddressSelector)
  const {
    transportModeFromScenePNNV,
    addlTransportModeDescriptorsPNNV,
    reasonForChoosingDestinationPNNV,
    hospitalCapabilityPNNV,
  } = destinationAddressState
  const {
    setDestinationAddressModeDescriptorsPNNV,
    setTransportModePNNV,
    setDestinationBasisPNNV,
    setDestinationCapabilitiesPNNV,
    setDestinationCapabilities,
    saveDestinationAddress,
  } = destinationAddressActions
  const configurationsState: IConfigurationsState = useSelector(getConfigurationsSelector)
  const { serviceConfig } = configurationsState
  const [isCountyEnabled, setIsCountyEnabled] = useState(false)

  const pickupAddressOptionsState = useSelector(getPickupAddressOptionsSelector)
  const {
    locationTypeOptions,
    commonAddressesOptions,
    otherTypeOptions,
    responseModeOptions,
    responseModeCustomOptions,
    stateOptions,
    pickUpAndDestinationCountyOptions,
    countryOptions,
    hospitalNameOptions,
    emsNameOptions,
    hospitalUnitOptions,
    sceneGridOptions,
  } = pickupAddressOptionsState

  const tripInformationState = useSelector(getTripInformationSelector)
  const { unit } = tripInformationState

  const destinationAddressOptionsState = useSelector(getDestinationAddressOptionsSelector)
  const {
    destinationBasisOptions,
    capabilities,
    hospitalOptions,
    emsOptions,
    transportModeOptions,
    transportModeCustomOptions,
  } = destinationAddressOptionsState
  const { errorMsgsMap, enableLocationSearch }: ILocationSearchState = useSelector(getLocationSearchState)

  let typeValue: IOption | null = null
  let otherType: IOption | IHospitalOption | null = null
  let location = ''
  let commonAddress: ICommonAddressesOption | null = null
  let addressLine1 = ''
  let addressLine2 = ''
  let aptSuiteRoom = ''
  let milePostMajorRoadway = ''
  let crossStreetDirections = ''
  let city: ICity | null = null
  let state: IOption | null = null
  let county: ICountyOption | null = null
  let zip = ''
  let country: IOption | null = null
  let censusTract = ''
  let refRecMD = ''
  let refRecRN = ''
  let refRecUSNG = ''
  let refRecGPSN = ''
  let refRecGPSE = ''
  let responseMode: IOption | null = null
  let hospitalUnit: IOption | null = null
  let sceneGrid: IOption | null = null
  let modeDescriptors: IOptions = []
  let RFT = ''
  let refRecMdOther = ''
  let destinationBasis: IOptions = []
  let modeDescriptorsOptions: IOptions = []
  let hospitalCapability: IOptions = []
  let hospitalNameSelectOptions: IOptions | IHospitalOptions = []
  let emsNameSelectOptions: IOptions = []

  if (addressTypeSelected === 1) {
    typeValue = pickupAddressState.typeValue
    otherType = pickupAddressState.otherType
    location = pickupAddressState.location
    commonAddress = pickupAddressState.commonAddress
    addressLine1 = pickupAddressState.addressLine1
    addressLine2 = pickupAddressState.addressLine2
    aptSuiteRoom = pickupAddressState.aptSuiteRoom
    milePostMajorRoadway = pickupAddressState.milePostMajorRoadway
    crossStreetDirections = pickupAddressState.crossStreetDirections
    city = pickupAddressState.city
    state = pickupAddressState.state
    county = pickupAddressState.county
    zip = pickupAddressState.zip
    country = pickupAddressState.country
    censusTract = pickupAddressState.censusTract
    refRecMD = pickupAddressState.referringMD
    refRecRN = pickupAddressState.referringRN
    refRecUSNG = pickupAddressState.referringUSNG
    refRecGPSN = pickupAddressState.referringGPSN
    refRecGPSE = pickupAddressState.referringGPSE
    responseMode = pickupAddressState.responseMode
    hospitalUnit = pickupAddressState.hospitalUnit
    sceneGrid = pickupAddressState.sceneGrid
    modeDescriptors = pickupAddressState.modeDescriptors
    RFT = pickupAddressState.RFT
    refRecMdOther = pickupAddressState.referringMdOther
    modeDescriptorsOptions = pickupAddressOptionsState.modeDescriptorsOptions
    hospitalNameSelectOptions = hospitalNameOptions
    emsNameSelectOptions = emsNameOptions
  } else if (addressTypeSelected === 2) {
    typeValue = destinationAddressState.typeValue
    otherType = destinationAddressState.destination.txToCode
    commonAddress = destinationAddressState.destination.commonAddress
    location = destinationAddressState.destination.name
    addressLine1 = destinationAddressState.destination.addressLine1
    addressLine2 = destinationAddressState.destination.addressLine2
    aptSuiteRoom = destinationAddressState.destination.aptSuiteRoom
    milePostMajorRoadway = destinationAddressState.destination.milePostMajorRoadway
    crossStreetDirections = destinationAddressState.destination.crossStreetDirections
    city = destinationAddressState.destination.city
    state = destinationAddressState.destination.state
    county = destinationAddressState.destination.county
    zip = destinationAddressState.destination.zip
    country = destinationAddressState.destination.country
    censusTract = destinationAddressState.destination.censusTract
    refRecRN = destinationAddressState.receivingNurse
    refRecMD = destinationAddressState.receivingMdText
    refRecUSNG = destinationAddressState.destination.usng
    refRecGPSN = destinationAddressState.destination.gpsn
    refRecGPSE = destinationAddressState.destination.gpse
    responseMode = destinationAddressState.transportModeFromScene
    hospitalUnit = destinationAddressState.hospitalInPatientDestination
    modeDescriptors = destinationAddressState.addlTransportModeDescriptors
    RFT = destinationAddressState.comment
    destinationBasis = destinationAddressState.reasonForChoosingDestination
    sceneGrid = destinationAddressState.destination.grid
    modeDescriptorsOptions = destinationAddressOptionsState.modeDescriptorsOptions
    hospitalCapability = destinationAddressState.hospitalCapability
    hospitalNameSelectOptions = hospitalOptions
    emsNameSelectOptions = emsOptions
  }

  const checkPickupConfigAndValues =
    serviceConfig.PR_MODE_DESCRIPTORS === 1 ||
    Boolean(pickupAddressState.modeDescriptorsPNNV?.name || modeDescriptors.length)

  const setTypeOnChange = (option: IOption) => {
    if (addressTypeSelected === 1) {
      dispatch(pickupAddressActions.setTypeValue(option))
      if (option && option.id === 1) {
        dispatch(pickupAddressActions.setDefaultEMSCode())
      } else if (option && option.id === 2) {
        dispatch(pickupAddressActions.setDefaultHospitalCode())
      }
    } else if (addressTypeSelected === 2) {
      dispatch(destinationAddressActions.setTypeValue(option))
      if (option && option.id === 2) {
        dispatch(destinationAddressActions.setDefaultHospitalCode())
      }
      if (option && option.id === 1) {
        dispatch(destinationAddressActions.setDefaultEMSCode())
      }
    }
  }

  const setOtherTypeOnChange = (option: IOption | null) => {
    if (addressTypeSelected === 1) {
      if (!option) {
        if (typeValue && typeValue?.id === 1) dispatch(pickupAddressActions.setDefaultEMSCode())
        else if (typeValue && typeValue?.id === 2) dispatch(pickupAddressActions.setDefaultHospitalCode())
        else dispatch(pickupAddressActions.setOtherType(option)) //if it is not hospital/ems, set it back to null
      } else dispatch(pickupAddressActions.setOtherType(option))
    } else if (addressTypeSelected === 2) {
      dispatch(destinationAddressActions.setOtherType(option))
    }
  }

  const setCommonAddressOnChange = (option: ICommonAddressesOption) => {
    if (addressTypeSelected === 1) {
      dispatch(pickupAddressActions.setCommonAddress(option))
    } else if (addressTypeSelected === 2) {
      dispatch(destinationAddressActions.setCommonAddress(option))
    }
  }

  const setHospitalunitOnChange = (option: IOption) => {
    if (addressTypeSelected === 1) {
      dispatch(pickupAddressActions.setHospitalUnit(option))
    } else if (addressTypeSelected === 2) {
      dispatch(destinationAddressActions.setHospitalInPatientDestination(option))
    }
  }

  const setSceneGridOnChange = (option: IOption) => {
    if (addressTypeSelected === 1) {
      dispatch(pickupAddressActions.setSceneGrid(option))
    } else if (addressTypeSelected === 2) {
      dispatch(destinationAddressActions.setDestinationGrid(option))
    }
  }

  const setLocationOnChange = (e: CustomEvent) => {
    e.preventDefault()
    if (addressTypeSelected === 1) {
      dispatch(pickupAddressActions.setLocation(e.detail.value))
    } else if (addressTypeSelected === 2) {
      dispatch(destinationAddressActions.setLocation(e.detail.value))
    }
  }

  const setAddressLine1OnChange = (e: CustomEvent) => {
    e.preventDefault()
    if (addressTypeSelected === 1) {
      dispatch(pickupAddressActions.setAddressLine1(e.detail.value))
    } else if (addressTypeSelected === 2) {
      dispatch(destinationAddressActions.setAddressLine1(e.detail.value))
    }
  }

  const setAddressLine2OnChange = (e: CustomEvent) => {
    e.preventDefault()
    if (addressTypeSelected === 1) {
      dispatch(pickupAddressActions.setAddressLine2(e.detail.value))
    } else if (addressTypeSelected === 2) {
      dispatch(destinationAddressActions.setAddressLine2(e.detail.value))
    }
  }

  const setAptSuiteRoomOnChange = (e: CustomEvent) => {
    e.preventDefault()
    if (addressTypeSelected === 1) {
      dispatch(pickupAddressActions.setAptSuiteRoom(e.detail.value))
    } else if (addressTypeSelected === 2) {
      dispatch(destinationAddressActions.setAptSuiteRoom(e.detail.value))
    }
  }

  const setMilePostMajorRoadwayOnChange = (e: CustomEvent) => {
    e.preventDefault()
    if (addressTypeSelected === 1) {
      dispatch(pickupAddressActions.setMilePostMajorRoadway(e.detail.value))
    } else if (addressTypeSelected === 2) {
      dispatch(destinationAddressActions.setMilePostMajorRoadway(e.detail.value))
    }
  }

  const setCrossStreetDirectionsOnChange = (e: CustomEvent) => {
    e.preventDefault()
    if (addressTypeSelected === 1) {
      dispatch(pickupAddressActions.setCrossStreetDirections(e.detail.value))
    } else if (addressTypeSelected === 2) {
      dispatch(destinationAddressActions.setCrossStreetDirections(e.detail.value))
    }
  }

  const setCityOnChange = (e: CustomEvent) => {
    e.preventDefault()
    const updatedCity: ICity | null = e.detail.value ? { name: e.detail.value, nemsisCode: '' } : null
    if (updatedCity && e.detail.value === city?.name && city?.nemsisCode) {
      updatedCity.nemsisCode = city.nemsisCode
    }
    if (addressTypeSelected === 1) {
      dispatch(pickupAddressActions.setCity(updatedCity))
    } else if (addressTypeSelected === 2) {
      dispatch(destinationAddressActions.setCity(updatedCity))
    }
  }

  const getCityNemsisCode = () => {
    if (addressTypeSelected === 1) {
      dispatch(getRefCityNemsisCode())
    } else if (addressTypeSelected === 2) {
      dispatch(getRecCityNemsisCode())
    }
  }

  const setStateOnChange = (option: IOption) => {
    if (county?.state !== option?.id) {
      setCountyOnChange(null)
    }

    if (addressTypeSelected === 1) {
      dispatch(pickupAddressActions.setState(option))
    } else if (addressTypeSelected === 2) {
      dispatch(destinationAddressActions.setState(option))
    }
  }

  const setCountyOnChange = (option: ICountyOption | null) => {
    if (addressTypeSelected === 1) {
      dispatch(pickupAddressActions.setCounty(option))
    } else if (addressTypeSelected === 2) {
      dispatch(destinationAddressActions.setCounty(option))
    }
  }

  const setCountryOnChange = (option: IOption) => {
    if (addressTypeSelected === 1) {
      dispatch(pickupAddressActions.setCountry(option))
    } else if (addressTypeSelected === 2) {
      dispatch(destinationAddressActions.setCountry(option))
    }
  }

  const setZipOnChange = (numbers: string[]) => {
    if (addressTypeSelected === 1) {
      dispatch(pickupAddressActions.setZip(numbers.join('')))
      if (numbers.join('').length === 5) {
        dispatch(setZipState(numbers.join(''), PickupAddressConstants.SET_CITY, PickupAddressConstants.SET_STATE))
      }
    } else if (addressTypeSelected === 2) {
      dispatch(destinationAddressActions.setZip(numbers.join('')))
      if (numbers.join('').length === 5) {
        dispatch(
          setZipState(numbers.join(''), DestinationAddressConstants.SET_CITY, DestinationAddressConstants.SET_STATE)
        )
      }
    }
  }

  const setCensusTractOnChange = (numbers: string[]) => {
    if (addressTypeSelected === 1) {
      dispatch(pickupAddressActions.setCensusTract(numbers.join('')))
    } else if (addressTypeSelected === 2) {
      dispatch(destinationAddressActions.setCensusTract(numbers.join('')))
    }
  }

  // const setMCDOnChange = (e: CustomEvent) => {
  //   e.preventDefault()
  //   dispatch(setMCD(e.detail.value))
  // }

  const setRequesterOnChange = (e: CustomEvent) => {
    e.preventDefault()
    if (addressTypeSelected === 1) {
      dispatch(pickupAddressActions.setReferringMD(e.detail.value))
    }
  }

  const setReferringMDOnChange = (e: CustomEvent) => {
    e.preventDefault()
    if (addressTypeSelected === 1) {
      if (typeValue?.id === 2) {
        dispatch(pickupAddressActions.setReferringMD(e.detail.value))
      } else {
        dispatch(pickupAddressActions.setReferringMdOther(e.detail.value))
      }
    } else if (addressTypeSelected === 2) {
      dispatch(destinationAddressActions.setReceivingMD(e.detail.value))
    }
  }

  const setReferringRNOnChange = (e: CustomEvent) => {
    e.preventDefault()
    if (addressTypeSelected === 1) {
      dispatch(pickupAddressActions.setReferringRN(e.detail.value))
    } else if (addressTypeSelected === 2) {
      dispatch(destinationAddressActions.setReceivingRN(e.detail.value))
    }
  }
  const setReferringUSNGOnChange = (e: CustomEvent) => {
    e.preventDefault()
    if (addressTypeSelected === 1) {
      dispatch(pickupAddressActions.setReferringUSNG(e.detail.value))
    } else if (addressTypeSelected === 2) {
      dispatch(destinationAddressActions.setReceivingUSNG(e.detail.value))
    }
  }
  const setReferringGPSNOnChange = (numbers: string[]) => {
    if (addressTypeSelected === 1) {
      dispatch(pickupAddressActions.setReferringGPSN(numbers.join('')))
    } else if (addressTypeSelected === 2) {
      dispatch(destinationAddressActions.setReceivingGPSN(numbers.join('')))
    }
  }
  const setReferringGPSEOnChange = (numbers: string[]) => {
    if (addressTypeSelected === 1) {
      dispatch(pickupAddressActions.setReferringGPSE(numbers.join('')))
    } else if (addressTypeSelected === 2) {
      dispatch(destinationAddressActions.setReceivingGPSE(numbers.join('')))
    }
  }

  const calculateUsng = () => {
    if (refRecGPSN !== '' && refRecGPSE !== '' && serviceConfig.PR_USNG === 1) {
      if (addressTypeSelected === 1) {
        dispatch(pickupAddressActions.calculateReferringUsng())
      } else if (addressTypeSelected === 2) {
        dispatch(destinationAddressActions.calculateReceivingUsng())
      }
    }
  }

  const setRFTOnChange = (e: CustomEvent) => {
    e.preventDefault()
    if (addressTypeSelected === 1) {
      dispatch(pickupAddressActions.setRFT(e.detail.value))
    } else if (addressTypeSelected === 2) {
      dispatch(destinationAddressActions.setComment(e.detail.value))
    }
  }

  const setResponseModeOnChange = (option: IOption) => {
    if (addressTypeSelected === 1) {
      dispatch(pickupAddressActions.setResponseMode(option))
    } else if (addressTypeSelected === 2) {
      dispatch(destinationAddressActions.setTransportMode(option))
    }
  }

  const handleTransportModePNNV = (option: IPNNVOption | null) => {
    dispatch(setTransportModePNNV(option))
  }

  const getResponseModeOptions = () => {
    if (serviceConfig.PR_REFREC_MODE === 2 && responseModeCustomOptions?.length > 0) {
      return responseModeCustomOptions
    }
    return responseModeOptions
  }

  const getTransportModeOptions = () => {
    if (serviceConfig.PR_REFREC_MODE === 2 && transportModeCustomOptions?.length > 0) {
      return transportModeCustomOptions
    }
    return transportModeOptions
  }

  useIonViewWillEnter(() => {
    calculateUsng()
  })

  useIonViewDidEnter(() => {
    setFlag(true)
  })

  useIonViewDidLeave(() => {
    setFlag(false)
  })

  const handleCountyControlBasedOnState = () => {
    const enableCounty = state ? true : false

    if (enableCounty) {
      dispatch(pickupAddressActions.getCountyOptions())
    }

    setIsCountyEnabled(enableCounty)
  }

  const shouldShowGPSMap = (gpsN?: string, gpsE?: string) => {
    return gpsN && gpsE
  }

  const shouldShowAddressMap = (address?: string, zip?: string, city?: ICity | null, state?: IOption | null) => {
    return (address && zip) || (address && city?.name && state?.name)
  }

  const isGoogleMapVisible =
    shouldShowGPSMap(refRecGPSN, refRecGPSE) || shouldShowAddressMap(addressLine1, zip, city, state)

  useEffect(() => {
    if (flag) {
      if (addressTypeSelected === 1) {
        location && dispatch(pickupAddressActions.setLocation(location))
        addressLine1 && dispatch(pickupAddressActions.setAddressLine1(addressLine1))
        addressLine2 && dispatch(pickupAddressActions.setAddressLine2(addressLine2))
        aptSuiteRoom && dispatch(pickupAddressActions.setAptSuiteRoom(aptSuiteRoom))
        milePostMajorRoadway && dispatch(pickupAddressActions.setMilePostMajorRoadway(milePostMajorRoadway))
        crossStreetDirections && dispatch(pickupAddressActions.setCrossStreetDirections(crossStreetDirections))
        city && dispatch(pickupAddressActions.setCity(city))
        zip && dispatch(pickupAddressActions.setZip(zip))
        if (zip && zip.length === 5 && !city && !state) {
          dispatch(setZipState(zip, PickupAddressConstants.SET_CITY, PickupAddressConstants.SET_STATE))
        }
        censusTract && dispatch(pickupAddressActions.setCensusTract(censusTract))
        refRecRN && dispatch(pickupAddressActions.setReferringRN(refRecRN))
        refRecUSNG && dispatch(pickupAddressActions.setReferringUSNG(refRecUSNG))
        refRecGPSN && dispatch(pickupAddressActions.setReferringGPSN(refRecGPSN))
        refRecGPSE && dispatch(pickupAddressActions.setReferringGPSE(refRecGPSE))
        RFT && dispatch(pickupAddressActions.setRFT(RFT))
      } else if (addressTypeSelected === 2) {
        location && dispatch(destinationAddressActions.setLocation(location))
        addressLine1 && dispatch(destinationAddressActions.setAddressLine1(addressLine1))
        addressLine2 && dispatch(destinationAddressActions.setAddressLine2(addressLine2))
        aptSuiteRoom && dispatch(destinationAddressActions.setAptSuiteRoom(aptSuiteRoom))
        milePostMajorRoadway && dispatch(destinationAddressActions.setMilePostMajorRoadway(milePostMajorRoadway))
        crossStreetDirections && dispatch(destinationAddressActions.setCrossStreetDirections(crossStreetDirections))
        city && dispatch(destinationAddressActions.setCity(city))
        zip && dispatch(destinationAddressActions.setZip(zip))
        if (zip && zip.length === 5 && !city && !state) {
          dispatch(setZipState(zip, DestinationAddressConstants.SET_CITY, DestinationAddressConstants.SET_STATE))
        }
        censusTract && dispatch(destinationAddressActions.setCensusTract(censusTract))
        refRecRN && dispatch(destinationAddressActions.setReceivingRN(refRecRN))
        refRecUSNG && dispatch(destinationAddressActions.setReceivingUSNG(refRecUSNG))
        refRecGPSN && dispatch(destinationAddressActions.setReceivingGPSN(refRecGPSN))
        refRecGPSE && dispatch(destinationAddressActions.setReceivingGPSE(refRecGPSE))
        RFT && dispatch(destinationAddressActions.setComment(RFT))
      }
    }
  }, [flag])

  useEffect(() => {
    handleCountyControlBasedOnState()
  }, [state])

  return (
    <>
      <IonItemDivider color='light' className='ion-padding'>
        <IonLabel className='grid-item-divider-label' color='medium'>
          {addressTypeSelected === 1
            ? t('pickupAddress.pickupAddressDetails')
            : t('destinationAddress.destinationDetails')}
        </IonLabel>
      </IonItemDivider>
      <IonList>
        <IonRow>
          <IonCol className='picklist'>
            <SingleSelect
              dataTestID='Type'
              options={locationTypeOptions}
              selectedOption={typeValue}
              listHeader={t('pickupAddress.type')}
              label={t('pickupAddress.type')}
              action={setTypeOnChange}
            />
          </IonCol>
        </IonRow>
        <hr className='field-divider' />
        {typeValue?.id === 0 && (
          <>
            <IonRow>
              <IonCol className='picklist'>
                <SingleSelect
                  dataTestID='CommonAddresses'
                  options={commonAddressesOptions}
                  selectedOption={commonAddress}
                  listHeader={t('pickupAddress.location')}
                  label={t('pickupAddress.location')}
                  action={setCommonAddressOnChange}
                />
              </IonCol>
            </IonRow>

            <hr className='field-divider' />

            <IonRow>
              <IonCol className='picklist'>
                <SingleSelect
                  dataTestID='OtherType'
                  options={otherTypeOptions}
                  selectedOption={otherType}
                  listHeader={t('pickupAddress.otherType')}
                  label={t('pickupAddress.otherType')}
                  action={setOtherTypeOnChange}
                />
              </IonCol>
            </IonRow>

            <hr className='field-divider' />
          </>
        )}
        {typeValue?.id === 2 && (
          <>
            <IonRow>
              <IonCol className='picklist'>
                <SingleSelect
                  dataTestID='HospitalName'
                  options={hospitalNameSelectOptions}
                  selectedOption={otherType}
                  listHeader={t('pickupAddress.hospitalName')}
                  label={t('pickupAddress.hospitalName')}
                  action={setOtherTypeOnChange}
                />
              </IonCol>
            </IonRow>
            <hr className='field-divider' />
          </>
        )}
        {typeValue?.id === 1 && (
          <>
            <IonRow>
              <IonCol className='picklist'>
                <SingleSelect
                  dataTestID='EMSName'
                  options={emsNameSelectOptions}
                  selectedOption={otherType}
                  listHeader={t('pickupAddress.emsName')}
                  label={t('pickupAddress.emsName')}
                  action={setOtherTypeOnChange}
                />
              </IonCol>
            </IonRow>
          </>
        )}
        {typeValue?.id === 2 && addressTypeSelected === 1 && (
          <>
            <IonItemDivider color='light' className='ion-padding'>
              <IonLabel className='grid-item-divider-label' color='medium'>
                {t('pickupAddress.transportDetails')}
              </IonLabel>
            </IonItemDivider>
            <hr className='field-divider' />

            <IonRow>
              <IonCol className='picklist'>
                <SingleSelect
                  dataTestID='Hospital'
                  options={hospitalUnitOptions}
                  selectedOption={hospitalUnit}
                  listHeader={t('pickupAddress.hospitalUnit')}
                  label={t('pickupAddress.hospitalUnit')}
                  action={setHospitalunitOnChange}
                />
              </IonCol>
            </IonRow>
            <hr className='field-divider' />

            {/* {typeValue?.id === 2 && (
              <>
                <hr className='field-divider'/>
                <IonRow>
                  <IonCol className='picklist'>
                    <SInput
                      label={t('pickupAddress.county')}
                      dataTestID='County'
                      inputValue={county}
                      onChangeAction={setCountyOnChange}
                    />
                    <Validation id={PickupAddressConstants.SET_COUNTY} />
                  </IonCol>
                </IonRow>
              </>
            )} */}
          </>
        )}
        {typeValue?.id === 2 && addressTypeSelected === 2 && (
          <>
            <IonRow>
              <IonCol className='picklist'>
                <SingleSelect
                  dataTestID='Hospital'
                  options={hospitalUnitOptions}
                  selectedOption={hospitalUnit}
                  listHeader={t('pickupAddress.hospitalUnit')}
                  label={t('pickupAddress.hospitalUnit')}
                  action={setHospitalunitOnChange}
                />
              </IonCol>
            </IonRow>
            <hr className='field-divider' />
          </>
        )}
        {typeValue?.id === 2 && addressTypeSelected === 2 && (
          <>
            <IonRow>
              <IonCol className='picklist'>
                <MultiSelect
                  dataTestID='Capabilities'
                  listHeader={t('destinationAddress.capabilities')}
                  options={capabilities}
                  savedValues={hospitalCapability}
                  action={setDestinationCapabilities}
                  label={t('destinationAddress.capabilities')}
                  callback={saveDestinationAddress}
                  pnnvAction={setDestinationCapabilitiesPNNV}
                  savedPNNVValue={hospitalCapabilityPNNV}
                />
              </IonCol>
            </IonRow>
          </>
        )}
        {(typeValue?.id === 1 || typeValue?.id === 0) && (
          <>
            <IonItemDivider color='light' className='ion-padding'>
              <IonLabel className='grid-item-divider-label' color='medium'>
                {t('pickupAddress.locationData')}
              </IonLabel>
            </IonItemDivider>

            <IonRow>
              <IonCol className='picklist'>
                <SInput
                  isPHI={isPHI}
                  label={t('pickupAddress.locationName')}
                  dataTestID='Location'
                  inputValue={location}
                  onChangeAction={setLocationOnChange}
                />
                <Validation
                  id={
                    addressTypeSelected === 1
                      ? PickupAddressConstants.SET_LOCATION
                      : DestinationAddressConstants.SET_LOCATION
                  }
                />
              </IonCol>
            </IonRow>

            <hr className='field-divider' />

            <IonGrid className='ion-no-padding'>
              <IonRow>
                <IonCol className='picklist'>
                  <SInput
                    isPHI={isPHI}
                    label={t('pickupAddress.addressLine1')}
                    dataTestID='Address1'
                    inputValue={addressLine1}
                    onChangeAction={setAddressLine1OnChange}
                  />
                  <Validation
                    id={
                      addressTypeSelected === 1
                        ? PickupAddressConstants.SET_ADDRESS_LINE1
                        : DestinationAddressConstants.SET_ADDRESS_LINE1
                    }
                  />
                </IonCol>

                {isGoogleMapVisible ? (
                  <IonCol size='auto' className='ion-text-end'>
                    {shouldShowGPSMap(refRecGPSN, refRecGPSE) ? (
                      <GoogleMap address={`${refRecGPSN},${refRecGPSE}`} />
                    ) : (
                      shouldShowAddressMap(addressLine1, zip, city, state) && (
                        <GoogleMap
                          address={addressLine1}
                          city={city?.name}
                          state={state?.name}
                          zip={zip}
                          country={country?.name}
                        />
                      )
                    )}
                  </IonCol>
                ) : null}
              </IonRow>
            </IonGrid>

            <hr className='field-divider' />
            <IonRow>
              <IonCol className='picklist'>
                <SInput
                  isPHI={isPHI}
                  label={t('pickupAddress.addressLine2')}
                  dataTestID='Address2'
                  inputValue={addressLine2}
                  onChangeAction={setAddressLine2OnChange}
                />
                <Validation
                  id={
                    addressTypeSelected === 1
                      ? PickupAddressConstants.SET_ADDRESS_LINE2
                      : DestinationAddressConstants.SET_ADDRESS_LINE2
                  }
                />
              </IonCol>
            </IonRow>
            <hr className='field-divider' />

            <IonRow>
              <IonCol className='picklist'>
                <SInput
                  isPHI={isPHI}
                  label={t('pickupAddress.aptSuiteRoom')}
                  dataTestID='AptSuiteRoom'
                  inputValue={aptSuiteRoom}
                  onChangeAction={setAptSuiteRoomOnChange}
                />
                <Validation
                  id={
                    addressTypeSelected === 1
                      ? PickupAddressConstants.SET_APT_SUITE_ROOM
                      : DestinationAddressConstants.SET_APT_SUITE_ROOM
                  }
                />
              </IonCol>
            </IonRow>

            <hr className='field-divider' />

            <IonRow>
              <IonCol className='picklist'>
                <SInput
                  label={t('pickupAddress.milePostMajorRoadway')}
                  dataTestID='MilePostMajorRoadway'
                  inputValue={milePostMajorRoadway}
                  onChangeAction={setMilePostMajorRoadwayOnChange}
                />
                <Validation
                  id={
                    addressTypeSelected === 1
                      ? PickupAddressConstants.SET_MILE_POST_MAJOR_ROADWAY
                      : DestinationAddressConstants.SET_MILE_POST_MAJOR_ROADWAY
                  }
                />
              </IonCol>
            </IonRow>

            <hr className='field-divider' />

            <IonRow>
              <IonCol className='picklist'>
                <SInput
                  isPHI={isPHI}
                  label={t('pickupAddress.crossStreetDirections')}
                  dataTestID='CrossStreetDirections'
                  inputValue={crossStreetDirections}
                  onChangeAction={setCrossStreetDirectionsOnChange}
                />
                <Validation
                  id={
                    addressTypeSelected === 1
                      ? PickupAddressConstants.SET_CROSS_STREET_DIRECTIONS
                      : DestinationAddressConstants.SET_CROSS_STREET_DIRECTIONS
                  }
                />
              </IonCol>
            </IonRow>

            <hr className='field-divider' />

            <IonRow>
              <IonCol className='picklist'>
                <NumberPad
                  isPHI
                  elementId='Zip'
                  dataTestId='Zip'
                  values={zip.toString().split('')}
                  label={t('pickupAddress.zip')}
                  onNumPadClick={setZipOnChange}
                  validCharacters={zipCodeKeys}
                />
                <Validation
                  id={addressTypeSelected === 1 ? PickupAddressConstants.SET_ZIP : DestinationAddressConstants.SET_ZIP}
                />
              </IonCol>
            </IonRow>

            <hr className='field-divider' />

            <IonRow>
              <IonCol className='picklist'>
                <SInput
                  isPHI={isPHI}
                  label={t('pickupAddress.city')}
                  dataTestID='City'
                  inputValue={city?.name || ''}
                  onChangeAction={setCityOnChange}
                  onBlurAction={getCityNemsisCode}
                />
                <Validation
                  id={
                    addressTypeSelected === 1 ? PickupAddressConstants.SET_CITY : DestinationAddressConstants.SET_CITY
                  }
                />
                {enableLocationSearch && (
                  <ValidationMessage
                    id={
                      addressTypeSelected === 1
                        ? `${PickupAddressConstants.SET_CITY}_ERROR`
                        : `${DestinationAddressConstants.SET_CITY}_ERROR`
                    }
                    message={
                      addressTypeSelected === 1
                        ? errorMsgsMap[PickupAddressConstants.SET_CITY]
                        : errorMsgsMap[DestinationAddressConstants.SET_CITY]
                    }
                  />
                )}
              </IonCol>
            </IonRow>

            <hr className='field-divider' />

            <IonRow>
              <IonCol className='picklist'>
                <SingleSelect
                  dataTestID='State'
                  selectedOption={state}
                  label={t('pickupAddress.state')}
                  listHeader={t('pickupAddress.state')}
                  options={stateOptions}
                  action={setStateOnChange}
                />
              </IonCol>
            </IonRow>

            <hr className='field-divider' />

            <IonRow>
              <IonCol className='picklist'>
                <SingleSelect
                  isPHI={isPHI}
                  listHeader={t('pickupAddress.county')}
                  label={t('pickupAddress.county')}
                  dataTestID='County'
                  options={pickUpAndDestinationCountyOptions}
                  selectedOption={county}
                  action={setCountyOnChange}
                  disabled={!isCountyEnabled}
                />
                {enableLocationSearch && (
                  <ValidationMessage
                    id={
                      addressTypeSelected === 1
                        ? `${PickupAddressConstants.SET_COUNTY}_ERROR`
                        : `${DestinationAddressConstants.SET_COUNTY}_ERROR`
                    }
                    message={
                      addressTypeSelected === 1
                        ? errorMsgsMap[PickupAddressConstants.SET_COUNTY]
                        : errorMsgsMap[DestinationAddressConstants.SET_COUNTY]
                    }
                  />
                )}
              </IonCol>
            </IonRow>

            <hr className='field-divider' />

            <IonRow>
              <IonCol className='picklist'>
                <SingleSelect
                  dataTestID='Country'
                  selectedOption={country}
                  label={t('pickupAddress.country')}
                  listHeader={t('pickupAddress.country')}
                  options={countryOptions}
                  action={setCountryOnChange}
                />
              </IonCol>
            </IonRow>

            <hr className='field-divider' />

            <IonRow>
              <IonCol className='picklist'>
                <NumberPad
                  elementId='CensusTract'
                  dataTestId='CensusTract'
                  values={censusTract.toString().split('')}
                  label={t('pickupAddress.censusTract')}
                  onNumPadClick={setCensusTractOnChange}
                />
                <Validation
                  id={
                    addressTypeSelected === 1
                      ? PickupAddressConstants.SET_CENSUS_TRACT
                      : DestinationAddressConstants.SET_CENSUS_TRACT
                  }
                />
              </IonCol>
            </IonRow>
          </>
        )}
        <IonItemDivider color='light' className='ion-padding'>
          <IonLabel className='grid-item-divider-label' color='medium'>
            {addressTypeSelected === 1
              ? t('pickupAddress.requesterAndReferringData')
              : t('destinationAddress.receivingData')}
          </IonLabel>
        </IonItemDivider>
        {/* <IonRow>
          <IonCol className='picklist'>
            <SInput label={t('pickupAddress.mCD')} dataTestID='MCD' inputValue={mCD} onChangeAction={setMCDOnChange} />
          </IonCol>
        </IonRow>
        <hr className='field-divider'/> */}
        {typeValue?.id === 0 && addressTypeSelected === 1 && (
          <>
            <IonRow>
              <IonCol className='picklist'>
                <SInput
                  label={t('pickupAddress.requester')}
                  dataTestID='Requester'
                  inputValue={refRecMD}
                  onChangeAction={setRequesterOnChange}
                />
                <Validation id={PickupAddressConstants.SET_REFERRING_MD} />
              </IonCol>
            </IonRow>
            <hr className='field-divider' />
            <IonRow>
              <IonCol className='picklist'>
                <SInput
                  label={t('pickupAddress.referringMD')}
                  dataTestID='ReferringMD'
                  inputValue={refRecMdOther}
                  onChangeAction={setReferringMDOnChange}
                />
                <Validation id={PickupAddressConstants.SET_REFERRING_MD_OTHER} />
              </IonCol>
            </IonRow>
            <hr className='field-divider' />
          </>
        )}
        {typeValue?.id === 2 && addressTypeSelected === 1 && (
          <>
            <IonRow>
              <IonCol className='picklist'>
                <SInput
                  label={t('pickupAddress.referringMD')}
                  dataTestID='ReferringMD'
                  inputValue={refRecMD}
                  onChangeAction={setReferringMDOnChange}
                />
                <Validation id={PickupAddressConstants.SET_REFERRING_MD} />
              </IonCol>
            </IonRow>
            <hr className='field-divider' />
          </>
        )}
        {(typeValue?.id === 2 || typeValue?.id === 0) && addressTypeSelected === 2 && (
          <>
            <IonRow>
              <IonCol className='picklist'>
                <SInput
                  label={t('destinationAddress.receivingMD')}
                  dataTestID='ReceivingMD'
                  inputValue={refRecMD}
                  onChangeAction={setReferringMDOnChange}
                />
                <Validation id={DestinationAddressConstants.SET_RECEIVING_MD} />
              </IonCol>
            </IonRow>
            <hr className='field-divider' />
          </>
        )}
        {(typeValue?.id === 2 || typeValue?.id === 0) && (
          <>
            <IonRow>
              <IonCol className='picklist'>
                <SInput
                  label={
                    addressTypeSelected === 1 ? t('pickupAddress.referringRN') : t('destinationAddress.receivingRN')
                  }
                  dataTestID='ReferringRN'
                  inputValue={refRecRN}
                  onChangeAction={setReferringRNOnChange}
                />
                <Validation
                  id={
                    addressTypeSelected === 1
                      ? PickupAddressConstants.SET_REFERRING_RN
                      : DestinationAddressConstants.SET_RECEIVING_RN
                  }
                />
              </IonCol>
            </IonRow>
            <hr className='field-divider' />
          </>
        )}
        {addressTypeSelected === 2 && (
          <>
            <IonRow>
              <IonCol className='picklist'>
                <MultiSelect
                  dataTestID='DestinationBasis'
                  listHeader={t('destinationAddress.destinationBasis')}
                  options={destinationBasisOptions}
                  savedValues={destinationBasis}
                  action={destinationAddressActions.setDestinationBasis}
                  callback={destinationAddressActions.saveDestinationAddress}
                  label={t('destinationAddress.destinationBasis')}
                  pnnvAction={setDestinationBasisPNNV}
                  savedPNNVValue={reasonForChoosingDestinationPNNV}
                />
              </IonCol>
            </IonRow>
            <hr className='field-divider' />
          </>
        )}
        <IonRow>
          <IonCol className='picklist'>
            <SingleSelect
              dataTestID='SceneGrid'
              options={sceneGridOptions}
              selectedOption={sceneGrid}
              listHeader={
                addressTypeSelected === 1 ? t('pickupAddress.sceneGrid') : t('destinationAddress.destinationGrid')
              }
              label={addressTypeSelected === 1 ? t('pickupAddress.sceneGrid') : t('destinationAddress.destinationGrid')}
              action={setSceneGridOnChange}
            />
          </IonCol>
        </IonRow>
        <hr className='field-divider' />
        <IonRow>
          <IonCol className='picklist'>
            <NumberPad
              elementId='ReferringGPSN'
              dataTestId='ReferringGPSN'
              values={refRecGPSN.toString().split('')}
              label={
                addressTypeSelected === 1 ? t('pickupAddress.referringGPSN') : t('destinationAddress.receivingGPSN')
              }
              onNumPadClick={setReferringGPSNOnChange}
              onBlur={calculateUsng}
              validCharacters={geoLocationKeys}
            />
            <Validation
              id={
                addressTypeSelected === 1
                  ? PickupAddressConstants.SET_REFERRING_GPS_N
                  : DestinationAddressConstants.SET_RECEIVING_GPS_N
              }
            />
          </IonCol>
          <IonCol className='picklist'>
            <NumberPad
              elementId='ReferringGPSE'
              dataTestId='ReferringGPSE'
              values={refRecGPSE.toString().split('')}
              label={
                addressTypeSelected === 1 ? t('pickupAddress.referringGPSE') : t('destinationAddress.receivingGPSE')
              }
              onNumPadClick={setReferringGPSEOnChange}
              onBlur={calculateUsng}
              validCharacters={geoLocationKeys}
            />
            <Validation
              id={
                addressTypeSelected === 1
                  ? PickupAddressConstants.SET_REFERRING_GPS_E
                  : DestinationAddressConstants.SET_RECEIVING_GPS_E
              }
            />
          </IonCol>
        </IonRow>
        <hr className='field-divider' />
        {serviceConfig.PR_USNG === 1 && (
          <>
            <IonRow>
              <IonCol className='picklist'>
                <SInput
                  label={
                    addressTypeSelected === 1 ? t('pickupAddress.referringUSNG') : t('destinationAddress.receivingUSNG')
                  }
                  dataTestID='ReferringUSNG'
                  inputValue={refRecUSNG}
                  onChangeAction={setReferringUSNGOnChange}
                  autoCapitalize='characters'
                />
                <Validation
                  id={
                    addressTypeSelected === 1
                      ? PickupAddressConstants.SET_REFERRING_USNG
                      : DestinationAddressConstants.SET_RECEIVING_USNG
                  }
                />
              </IonCol>
            </IonRow>
            <hr className='field-divider' />
          </>
        )}

        {addressTypeSelected === 1 ? (
          <>
            {(unit?.lights ?? 0) > 0 && (
              <>
                <IonRow>
                  <IonCol className='picklist'>
                    <SingleSelect
                      dataTestID='ResponseMode'
                      options={getResponseModeOptions()}
                      selectedOption={responseMode}
                      listHeader={t('pickupAddress.responseMode')}
                      label={t('pickupAddress.responseMode')}
                      action={setResponseModeOnChange}
                    />
                  </IonCol>
                </IonRow>
                <hr className='field-divider' />
              </>
            )}
          </>
        ) : (
          <>
            <IonRow>
              <IonCol className='picklist'>
                <SingleSelect
                  dataTestID='ResponseMode'
                  options={getTransportModeOptions()}
                  selectedOption={responseMode}
                  listHeader={t('destinationAddress.transportMode')}
                  label={t('destinationAddress.transportMode')}
                  action={setResponseModeOnChange}
                  pnnvAction={handleTransportModePNNV}
                  selectedPNNVOption={transportModeFromScenePNNV}
                />
              </IonCol>
            </IonRow>
            <hr className='field-divider' />
          </>
        )}
        {addressTypeSelected === 1 && checkPickupConfigAndValues ? (
          <>
            <IonRow>
              <IonCol className='picklist'>
                <MultiSelect
                  dataTestID='ModeDescriptors'
                  listHeader={t('pickupAddress.modeDescriptors')}
                  options={modeDescriptorsOptions}
                  savedValues={modeDescriptors}
                  action={pickupAddressActions.setModeDescriptors}
                  callback={pickupAddressActions.savePickupAddress}
                  label={t('pickupAddress.modeDescriptors')}
                  pnnvAction={pickupAddressActions.setPickupAddressModeDescriptorsPNNV}
                  savedPNNVValue={pickupAddressState.modeDescriptorsPNNV}
                />
              </IonCol>
            </IonRow>
            <hr className='field-divider' />
          </>
        ) : null}
        {addressTypeSelected === 2 ? (
          <>
            <IonRow>
              <IonCol className='picklist'>
                <MultiSelect
                  dataTestID='ModeDescriptors'
                  listHeader={t('pickupAddress.modeDescriptors')}
                  options={modeDescriptorsOptions}
                  savedValues={modeDescriptors}
                  action={destinationAddressActions.setModeDescriptors}
                  callback={destinationAddressActions.saveDestinationAddress}
                  label={t('pickupAddress.modeDescriptors')}
                  pnnvAction={setDestinationAddressModeDescriptorsPNNV}
                  savedPNNVValue={addlTransportModeDescriptorsPNNV}
                />
              </IonCol>
            </IonRow>
            <hr className='field-divider' />
          </>
        ) : null}
        <IonRow>
          <IonCol className='picklist'>
            <SInput
              dataTestID='RFT'
              label={addressTypeSelected === 1 ? t('pickupAddress.RFT') : t('destinationAddress.comment')}
              inputValue={RFT}
              onChangeAction={setRFTOnChange}
              setIsFocused={setIsFocused}
            />
            <Validation
              id={addressTypeSelected === 1 ? PickupAddressConstants.SET_RFT : DestinationAddressConstants.SET_COMMENT}
            />
          </IonCol>
        </IonRow>
        <IonItemDivider color='light' className='bottom-divider' />
      </IonList>
      {isFocused && (
        <IonItemDivider color='light' className={isTabletDevice ? 'bottom-divider-tablet' : 'bottom-divider-mobile'} />
      )}
    </>
  )
}

export default RefRecAddress
